module.exports = __webpack_public_path__ + "img/14.1-gallery.26419fa7.jpg";